import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function Sustainability() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/about-us">About Us</Link>
          <Link to="/dealers">Dealers &amp; Representatives</Link>
          <Link className="active" to="/sustainability">Sustainability</Link>
          <Link to="/refurbished">Refurbished Balers</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Company</span>
          <h2>Sustainability</h2>
          <div className="content-stack">
            <section className="content-block">
              <div className="selection-media-row reverse">
                <div className="selection-media-copy">
                  <div className="body-copy">Sustainability is more than environmental responsibility, it is about making the best use of available resources while improving <strong>operational efficiency</strong>.</div>
                  <div className="body-copy"><strong>C&amp;M Baling Systems</strong> helps organizations recover, process, and transport <strong>recyclable materials</strong> through equipment designed to support waste reduction, resource recovery, and long-term operational performance.</div>
                  <div className="body-copy">By improving the handling and densification of recyclable commodities, businesses can reduce <strong>transportation costs</strong>, improve <strong>storage efficiency</strong>, and maximize the value of recovered materials.</div>
                  <div className="body-copy">Our balers and <strong>material handling</strong> systems are engineered to support sustainable <strong>recycling operations</strong> while helping companies meet their environmental goals and operational objectives. Through innovative equipment design and practical solutions, C&amp;M continues to support a more efficient and sustainable future for the recycling and waste management industries.</div>
                </div>
                <img className="service-side-image" src="/img/thumbnails/SustainabilityLeftColumnPic1.jpg" alt="Tree representing sustainability" />
              </div>
            </section>
          </div>
          <Link className="button" to="/baler-selection-guide">Review the Selection Guide <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default Sustainability;
